class MegaMenu {
  constructor () {
    this.desktopNav = document.querySelector('.c-header__navigation--desktop')
    this.megaMenuItems = document.querySelectorAll('.c-header__desktop-menu > li')
    this.header = document.getElementById('header')
    this.hero = document.querySelector('.c-heroStyle4, .c-heroStyle6, .c-heroSlider, .c-heroBlog, .c-heroHome, .c-post__img-post, .c-heroAuthor, .c-heroSearch, .c-heroStyle5')

    this.expandTimeout = null
    this.collapseTimeout = null
    this.currentExpandedItem = null
    this.pendingAction = null

    this.EXPAND_DELAY = 100
    this.COLLAPSE_DELAY = 150

    // Para detectar movimiento del ratón
    this.mouseMovementDetected = false

    this.initHeroObserver()

    if (this.desktopNav && this.megaMenuItems.length > 0) {
      this.init()
      this.initMouseMovementDetection()
    }
  }

  initHeroObserver () {
    if (!this.hero) return

    const observer = new IntersectionObserver( // eslint-disable-line
      ([entry]) => {
        if (this.header) {
          if (entry.isIntersecting) {
            this.header.classList.remove('header-scrolled')
          } else {
            this.header.classList.add('header-scrolled')
          }
        }
      },
      {
        root: null,
        threshold: 0.1,
        rootMargin: '0px'
      }
    )

    observer.observe(this.hero)
  }

  initMouseMovementDetection () {
    const detectMovement = () => {
      this.mouseMovementDetected = true
      document.removeEventListener('mousemove', detectMovement)
    }

    document.addEventListener('mousemove', detectMovement)
  }

  init () {
    this.megaMenuItems.forEach(item => {
      const megaMenu = item.querySelector('ul.sub-menu')
      if (!megaMenu) return

      megaMenu.style.transform = 'translateX(-50%) translateY(-10px)'
      megaMenu.style.opacity = '0'
      megaMenu.style.visibility = 'hidden'

      item.addEventListener('mouseenter', (e) => {
        e.stopPropagation()
        if (this.mouseMovementDetected) {
          this.handleMouseEnter(item, megaMenu)
        }
      })

      item.addEventListener('mouseleave', (e) => {
        e.stopPropagation()
        this.handleMouseLeave(item, megaMenu)
      })

      megaMenu.addEventListener('mouseenter', (e) => {
        e.stopPropagation()
        clearTimeout(this.collapseTimeout)
        this.collapseTimeout = null
      })

      megaMenu.addEventListener('mouseleave', (e) => {
        e.stopPropagation()
        this.handleMouseLeave(item, megaMenu)
      })
    })

    this.desktopNav.addEventListener('mouseleave', (e) => {
      if (!this.desktopNav.contains(e.relatedTarget)) {
        this.handleMouseLeave(null, null)
      }
    })

    document.addEventListener('click', (e) => {
      if (this.currentExpandedItem && !this.desktopNav.contains(e.target)) {
        this.cancelPendingActions()
        this.executeCollapse()
      }
    })

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.currentExpandedItem) {
        this.cancelPendingActions()
        this.executeCollapse()
      }
    })

    let resizeTimer
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(() => {
        if (this.desktopNav.classList.contains('is-expanded') && this.currentExpandedItem) {
          const megaMenu = this.currentExpandedItem.querySelector('ul.sub-menu')
          if (megaMenu) {
            const navContentHeight = this.desktopNav.querySelector('.menu-header-content')?.offsetHeight || 0
            const megaMenuHeight = this.calculateMegaMenuHeight(megaMenu)
            const totalHeight = navContentHeight + megaMenuHeight + 30
            this.desktopNav.style.minHeight = totalHeight + 'px'
          }
        }
      }, 250)
    })
  }

  handleMouseEnter (item, megaMenu) {
    this.cancelPendingActions()

    if (this.currentExpandedItem === item && this.desktopNav.classList.contains('is-expanded')) {
      return
    }

    this.expandTimeout = setTimeout(() => {
      this.executeExpand(item, megaMenu)
    }, this.EXPAND_DELAY)

    this.pendingAction = { type: 'expand', item }
  }

  handleMouseLeave (item, megaMenu) {
    if (this.expandTimeout) {
      clearTimeout(this.expandTimeout)
      this.expandTimeout = null
      this.pendingAction = null
    }

    if (!this.expandTimeout) {
      this.collapseTimeout = setTimeout(() => {
        if (this.checkShouldCollapse(item, megaMenu)) {
          this.executeCollapse()
        }
      }, this.COLLAPSE_DELAY)
    }
  }

  checkShouldCollapse (item, megaMenu) {
    if (this.pendingAction && this.pendingAction.type === 'expand') {
      return false
    }

    const isAnyItemHovered = Array.from(this.megaMenuItems).some(menuItem => {
      return menuItem.matches(':hover') ||
        (menuItem.querySelector('ul.sub-menu') &&
          menuItem.querySelector('ul.sub-menu').matches(':hover'))
    })

    const isNavHovered = this.desktopNav.matches(':hover')

    return !isAnyItemHovered && !isNavHovered
  }

  executeExpand (item, megaMenu) {
    this.pendingAction = null

    if (this.currentExpandedItem === item && this.desktopNav.classList.contains('is-expanded')) {
      return
    }

    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout)
      this.collapseTimeout = null
    }

    // Si hay un item expandido diferente, ocultarlo rápidamente
    if (this.currentExpandedItem && this.currentExpandedItem !== item) {
      this.hideCurrentItemQuickly(() => {
        this.performExpand(item, megaMenu)
      })
    } else {
      this.performExpand(item, megaMenu)
    }
  }

  hideCurrentItemQuickly (callback) {
    if (!this.currentExpandedItem) {
      if (callback) callback()
      return
    }

    const megaMenu = this.currentExpandedItem.querySelector('ul.sub-menu')
    if (megaMenu) {
      // Transición rápida de salida (0.1s)
      megaMenu.style.transition = 'opacity 0.1s ease, transform 0.1s ease'
      megaMenu.style.opacity = '0'
      megaMenu.style.visibility = 'hidden'
      megaMenu.style.transform = 'translateX(-50%) translateY(-10px)'
      this.currentExpandedItem.classList.remove('is-mega-active')
    }

    // Esperar a que termine la animación rápida antes de mostrar el nuevo
    setTimeout(() => {
      if (megaMenu) megaMenu.style.transition = ''
      if (callback) callback()
    }, 100)
  }

  performExpand (item, megaMenu) {
    const navContentHeight = this.desktopNav.querySelector('.menu-header-content')?.offsetHeight || 0
    const megaMenuHeight = this.calculateMegaMenuHeight(megaMenu)
    const totalHeight = navContentHeight + megaMenuHeight + 30

    this.desktopNav.style.transition = 'min-height 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
    this.desktopNav.style.minHeight = totalHeight + 'px'
    this.desktopNav.style.maxHeight = 'none'
    this.desktopNav.style.overflowY = 'visible'
    this.desktopNav.classList.add('is-expanded')

    // Mostrar el nuevo megamenu inmediatamente
    requestAnimationFrame(() => { // eslint-disable-line
      this.desktopNav.style.backdropFilter = 'blur(10px)'
      this.desktopNav.style.webkitBackdropFilter = 'blur(10px)'

      megaMenu.style.transition = 'opacity 0.2s ease, transform 0.2s ease'
      megaMenu.style.opacity = '1'
      megaMenu.style.visibility = 'visible'
      megaMenu.style.transform = 'translateX(-50%) translateY(0)'
      item.classList.add('is-mega-active')

      this.currentExpandedItem = item

      setTimeout(() => {
        megaMenu.style.transition = ''
      }, 200)
    })
  }

  executeCollapse () {
    this.pendingAction = null

    if (!this.currentExpandedItem) return

    const megaMenu = this.currentExpandedItem.querySelector('ul.sub-menu')
    if (megaMenu) {
      megaMenu.style.transition = 'opacity 0.2s ease, transform 0.2s ease'
      megaMenu.style.opacity = '0'
      megaMenu.style.visibility = 'hidden'
      megaMenu.style.transform = 'translateX(-50%) translateY(-10px)'
      this.currentExpandedItem.classList.remove('is-mega-active')
    }

    setTimeout(() => {
      this.desktopNav.classList.remove('is-expanded')
      this.desktopNav.style.minHeight = ''
      this.desktopNav.style.maxHeight = ''
      this.desktopNav.style.overflowY = ''
      this.desktopNav.style.transition = ''
      this.desktopNav.style.backdropFilter = ''
      this.desktopNav.style.webkitBackdropFilter = ''

      if (megaMenu) megaMenu.style.transition = ''

      this.currentExpandedItem = null
    }, 200)
  }

  cancelPendingActions () {
    if (this.expandTimeout) {
      clearTimeout(this.expandTimeout)
      this.expandTimeout = null
    }

    if (this.collapseTimeout) {
      clearTimeout(this.collapseTimeout)
      this.collapseTimeout = null
    }

    this.pendingAction = null
  }

  calculateMegaMenuHeight (megaMenu) {
    const originalStyles = {
      display: megaMenu.style.display,
      visibility: megaMenu.style.visibility,
      opacity: megaMenu.style.opacity,
      position: megaMenu.style.position,
      top: megaMenu.style.top,
      transform: megaMenu.style.transform,
      transition: megaMenu.style.transition
    }

    Object.assign(megaMenu.style, {
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      position: 'absolute',
      top: '-9999px',
      left: '50%',
      transform: 'translateX(-50%) translateY(0)',
      zIndex: '-1',
      transition: 'none'
    })

    const height = megaMenu.offsetHeight
    Object.assign(megaMenu.style, originalStyles)
    return height
  }
}

export default MegaMenu
